(() => {
  if (window.__bfCardAudioClickPatchInitialized) return;
  window.__bfCardAudioClickPatchInitialized = true;

  const patch = (wrapper) => {
    if (!wrapper) return;
    const inner = wrapper.querySelector('.card__inner');
    const productLink = wrapper.querySelector('.card__heading a[href*="/products/"]');
    if (!inner || !productLink || inner.querySelector('.card-audio-preview__image-link')) return;

    const imageLink = document.createElement('a');
    imageLink.className = 'card-audio-preview__image-link';
    imageLink.href = productLink.href;
    imageLink.tabIndex = -1;
    imageLink.setAttribute('aria-hidden', 'true');
    inner.appendChild(imageLink);
  };

  const scan = (root = document) => {
    root.querySelectorAll?.('.product-card-wrapper').forEach(patch);
  };

  const handleCardCoverClick = (event) => {
    if (event.defaultPrevented || event.button !== 0) return;

    const target = event.target;
    if (!(target instanceof Element)) return;

    const inner = target.closest('.product-card-wrapper .card__inner');
    if (!inner || !inner.querySelector('.card__media')) return;

    if (
      target.closest(
        '.card-audio-preview__image-link, [data-card-audio-preview], .card-wishlist, button, a, input, select, textarea, [role="button"]'
      )
    ) {
      return;
    }

    const wrapper = inner.closest('.product-card-wrapper');
    const productLink = wrapper?.querySelector('.card__heading a[href*="/products/"]');
    if (!productLink) return;

    if (event.metaKey || event.ctrlKey) {
      window.open(productLink.href, '_blank', 'noopener');
      return;
    }

    productLink.click();
  };

  const start = () => {
    scan();
    document.addEventListener('click', handleCardCoverClick);

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (!(node instanceof Element)) continue;
          if (node.matches('.product-card-wrapper')) patch(node);
          scan(node);
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
